export function checkMobileDevice () {
    const body = document.getElementsByTagName('body')[0];
    return body.classList.contains('mobile-device');
}

export const isMobileDevice = checkMobileDevice();
